Ext.define('SA.view.AliasWindow', {
    alias: 'widget.location-alias-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-location-alias-window',
    includeCancelBtn: true,

    initComponent() {
        var alias = this.location.locationAlias || '';

        this.callParent();

        this.aliasTextField = this.down('#aliasTextField');
        this.aliasTextField.setValue(alias);
    },

    afterRender() {
        this.callParent();

        this.aliasTextField.focus();
    },

    getBodyItems() {
        return [
            {
                xtype: 'component',
                cls: 'sa-location-alias-window-field-label',
                html: 'Alias:'
            }, {
                xtype: 'sa-textfield',
                cls: 'sa-location-alias-window-field-input',
                height: 35,
                itemId: 'aliasTextField',
                selectOnFocus: true
            }
        ];
    },

    getFooterItems() {
        return {
            xtype: 'sa-button',
            handler: this.onSaveClick.bind(this),
            text: 'Save',
            ui: 'primary'
        };
    },

    getTitle() {
        var location = this.location,
            alias = location.locationAlias || '';

        return (alias ? 'Edit' : 'Add') + ' alias for ' + Ext.String.htmlEncode(location.name);
    },

    onSaveClick() {
        var alias = this.aliasTextField.getValue().trim();

        SA.data.LocationAliases.set(SA.data.LocationsCache.toLocationSeries(this.location), alias);

        this.destroy();
    }
});
